import { stringSearch, useSetSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { RiskDigestPage } from '@/areas/risk-management/RiskDigest/RiskDigestPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/risk-management/risk-digest')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ start: 'optional', end: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const start = Route.useSearch({ select: (search) => search.start });
    const end = Route.useSearch({ select: (search) => search.end });
    const setSearch = useSetSearch();
    return <RiskDigestPage start={start} end={end} onSearchChange={setSearch} />;
}
